import Airtable from "airtable";

const base = new Airtable({ apiKey: "keyYszkZ96pQMUvSj" }).base(
  "apprxa9ij9jvqdF7j"
);

export default base;
